module.exports = __webpack_public_path__ + "static/media/CircularStd-Book.9e311611.ttf";